export enum IntakeEvictionType {
  INTAKE_FORM = 'Intake Form',
  EXISTING_CLIENT = 'Existing Client',
  BULK_IMPORT = 'Bulk Import',
  /** Property-linked PM handoff submission — the attorney resolves the client via the property link. */
  PROPERTY_MANAGER = 'Property Manager'
}
